import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, Modal } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';

export const ModalConfirmId = 'ModalConfirm';

const ModalConfirm = ({
  mediaIsPhone,
  modalClose,
  title,
  children,
  onClick,
}) => {
  const scrollableAreaRef = useRef(null);

  return (
    <Modal
      title={title}
      modalId={ModalConfirmId}
      scrollableAreaRef={scrollableAreaRef}
      compact
    >
      <ScrollableArea ref={scrollableAreaRef}>{children}</ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="conferma"
          fullsize={mediaIsPhone}
          onClick={() => {
            onClick();
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalConfirm.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state

  // dispatch
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      return {};
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
    })
  ),
  withMediaQueries
)(ModalConfirm);
